<template>
  <v-row
    no-gutters
  >
    <v-col
      class="text-center text-h3"
    >
      <font-awesome-icon
        :icon="['fas', 'spinner']"
        spin
        size="2x"
      />
    </v-col>
  </v-row>
</template>

<script>
import { useAuthStore } from '@/store/auth.module';
export default {
  name: 'OauthRedirect',
  mounted() {
    const authorizationCode = this.$route.query.code;
    const authStore = useAuthStore();
    authStore.getAccessToken(authorizationCode)
      .then(() => {
        this.$router.push('/mega-league');
      })
      .catch(() => {
        this.$router.push('/login');
      });
  },
};
</script>
